export default __webpack_public_path__ + "static/media/vacations.2c2d3d42.svg";